
export default {
    name: 'MobileSideBar',

    components: {
        MobileMenuElement: () => import('./_MobileMenuElement.vue'),
    },

    data() {
        return {};
    },

    computed: {
        menuList() {
            const items = this.$store.state?.cms?.menus?.default?.items || [];

            return items.filter((t) => Boolean(!t.isHidden));
        },
        phoneNumber() {
            return this.$store.state?.appState?.vars?.['Контактный телефон'];
        },
        socials() {
            const config = this.$store?.state?.appState?.config || {};
            const vars = this.$store?.state?.appState?.vars || {};

            const list = [];
            if (config.vkontakte) {
                list.push({
                    url: config.vkontakte,
                    icon: require('~/assets/img/svg/socials/vk-black.svg'),
                });
            }
            if (config.whatsapp) {
                list.push({
                    url: config.whatsapp,
                    icon: require('~/assets/img/svg/socials/whatsap-black.svg'),
                });
            }
            if (config.telegram) {
                list.push({
                    url: config.telegram,
                    icon: require('~/assets/img/svg/socials/telegram-black.svg'),
                });
            }
            if (vars?.['Ссылка на дом клик']) {
                list.push({
                    url: vars?.['Ссылка на дом клик'],
                    icon: require('~/assets/img/svg/socials/dom-click-black.svg'),
                });
            }
            return list;
        },

        isOpen() {
            return this.$store.state['mobile-side-bar'].isOpen || false;
        },

      linkPdfFile: function () {
        return this.$store.state?.appState?.vars?.['Презентация ЖК']
      },
    },

    methods: {
      closeSideBar() {
        this.$store.commit('mobile-side-bar/setOpen', false);
      },
      openSendPresentationPopupForm: function() {
        this.$store.commit('pop-up-send-presentation/setOpen', {
          open: true,
          settings: {
            title: 'Получить презентацию',
            reachGoal: '',
          }
        });
      },
    },
};
